<template>
  <div class="user-history-activity">
    <h1>{{ $t('teamTaskDetail.userHistoryActivity') }}</h1>
    <div class="fcsb">
      <Dates :date="this.convertDate(this.teamtaskDetail.created)" :title="$t('teamTaskDetail.requestTime')" color="#556BE6" />
      <Dates :date="this.convertDate(this.teamtaskDetail.updated)" :title="$t('teamTaskDetail.lastChangeTime')" color="#F6816E" />
    </div>
    <div class="mt-3" @click="$emit('showAssigneModal')">
      <FancyProgressBar :progress="giveMeDay(created, sla, slaGoal)"  />
    </div>
  </div>
</template>

<script>
import Dates from './Dates'
import FancyProgressBar from '../progressbars/FancyProgressBar'
import { teamTaskMixins } from '../../../utils/mixins'
export default {
  name: 'user-history-activity',
  mixins: [teamTaskMixins],
  components: {
    Dates,
    FancyProgressBar,
  },
  computed: {
    sla() {
      return this.teamtaskDetail.sla
    },
    slaGoal() {
      return this.teamtaskDetail.slaGoal
    },
    created() {
      return this.teamtaskDetail.created
    },
  },
}
</script>

<style scoped lang='scss'>
@import '../../../design/globalCss.scss';
.user-history-activity {
  background-color: white;
  min-width: 100%;
  padding: 16px;
}
h1 {
  font-family: IRANSans-bold;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  color: $dark-color;
  margin-bottom: 16px;
}
</style>